import Store from '@stores/store.js';

export default config => new Store(config);
